module.exports = __webpack_public_path__ + "files/e0a4fcccb1678c5fb168a2fe3f37d46f.png";